import React from 'react';
import { Box } from '@mui/material';
// Using new design system components
import { Typography, Button } from '../../../design-system';

interface ProfessionalDashboardProps {
  professionalId: string;
  onNavigate: (component: string) => void;
}

const ProfessionalDashboard: React.FC<ProfessionalDashboardProps> = ({ 
  professionalId, 
  onNavigate 
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Typography variant="h4" component="h1">
        Dashboard Profissional
      </Typography>
      <Typography variant="body1" color="secondary">
        Componente em desenvolvimento
      </Typography>
      <Box sx={{ display: 'flex', gap: 2 }}>
        <Button
          onClick={() => onNavigate('agenda')}
          variant="primary"
          startIcon={<span>📅</span>}
        >
          Ver Agenda
        </Button>
        <Button
          onClick={() => onNavigate('billing')}
          variant="secondary"
          startIcon={<span>💰</span>}
        >
          Faturamento
        </Button>
      </Box>
    </Box>
  );
};

export default ProfessionalDashboard;